import React from 'react';
import { type BrevoSyncRitmoPunto } from '../../api/brevoSyncApi';
import { fct } from '../../fct/tokens/tokens';

interface RitmoSparklineProps {
  puntos: BrevoSyncRitmoPunto[];
  width?: number;
  height?: number;
  color?: string;
}

/**
 * Sparkline del manual (GCVSC-I001 R-15): línea en `serie-01` sin relleno, eje base en la tinta
 * de eje y el último punto destacado en lima. Mismos datos que antes.
 */
const RitmoSparkline: React.FC<RitmoSparklineProps> = ({ puntos, width = 120, height = 36, color = fct.grafico['serie-01'] }) => {
  if (puntos.length < 2) return null;

  const values = puntos.map(p => p.contactos);
  const max = Math.max(...values, 1);
  const padding = 3;
  const w = width - padding * 2;
  const h = height - padding * 2;

  const coords = values.map((v, i) => ({
    x: padding + (i / (values.length - 1)) * w,
    y: padding + h - (v / max) * h,
  }));
  const points = coords.map(({ x, y }) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const ultimo = coords[coords.length - 1];
  const base = (padding + h).toFixed(1);

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }} aria-hidden="true">
      <line x1={padding} y1={base} x2={padding + w} y2={base} stroke={fct.grafico.eje} strokeWidth="1" />
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx={ultimo.x.toFixed(1)} cy={ultimo.y.toFixed(1)} r="2.5" fill={fct.grafico.destacado} stroke={color} strokeWidth="1" />
    </svg>
  );
};

export default RitmoSparkline;
